"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eraseCookie = exports.getCookie = exports.setCookie = void 0;
const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
};
exports.setCookie = setCookie;
const getCookie = (name) => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.startsWith(" "))
            c = c.substring(1, c.length);
        if (c.startsWith(nameEQ))
            return c.substring(nameEQ.length, c.length);
    }
    return null;
};
exports.getCookie = getCookie;
const eraseCookie = (name) => {
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};
exports.eraseCookie = eraseCookie;
//# sourceMappingURL=cookie.js.map